import { config } from '../config.js'
import { get } from '../services/http.js'


export let getEvent = async function (id) {
  return await get(`${config.apiUrl}/events/${id}`)
};

export let getEvents = async function () {
  let data = await get(`${config.apiUrl}/events`)
  return data.events || [];
};